/* eslint-disable no-undef */
export const technicalSkills = [
	{
		skill: "JavaScript",
		value: 90,
		color: "yellow",
		image: "/assets/JS.jpg"
	},
	{
		skill: "TypeScript",
		value: 70,
		color: "blue",
		image: "/assets/TypeScript.svg"
	},
	{
		skill: "HTML",
		value: 100,
		color: "orange",
		image: "/assets/HTML.png"
	},
	{
		skill: "CSS",
		value: 90,
		color: "blue",
		image: "/assets/CSS.png"
	},
	{
		skill: "NodeJS",
		value: 60,
		color: "grey",
		image: "/assets/Node.jpg"
	},
	{
		skill: "React",
		value: 90,
		color: "blue",
		image: "/assets/React.jpg"
	},
	{
		skill: "Redux",
		value: 60,
		color: "purple",
		image: "/assets/Redux.png"
	},
	{
		skill: "Gatsby",
		value: 70,
		color: "purple",
		image: "/assets/Gatsby.png"
	},
	{
		skill: "React Native",
		value: 80,
		color: "blue",
		image: "/assets/RNIcon.png"
	},
	{
		skill: "GraphQL",
		value: 40,
		color: "pink",
		image: "/assets/GraphQL.png"
	},
	{
		skill: "VueJS",
		value: 50,
		color: "green",
		image: "/assets/Vue.png"
	},
	{
		skill: "NuxtJS",
		value: 70,
		color: "green",
		image: "/assets/Nuxt.jpg"
	},
	{
		skill: "Vuex",
		value: 50,
		color: "green",
		image: "/assets/Vuex.png"
	},
	{
		skill: "Sass",
		value: 50,
		color: "pink",
		image: "/assets/Sass.png"
	},
	{
		skill: "Git",
		value: 80,
		color: "red",
		image: "/assets/Git.png"
	},
	{
		skill: "Github",
		value: 80,
		color: "black",
		image: "/assets/Github.png"
	},
	{
		skill: "Semantic UI",
		value: 90,
		color: "teal",
		image: "/assets/SemanticUI.png"
	},
	{
		skill: "Bootstrap",
		value: 80,
		color: "violet",
		image: "/assets/Bootstrap.png"
	},
	{
		skill: "Ubuntu",
		value: 60,
		color: "orange",
		image: "/assets/Ubuntu.jpeg"
	},
	{
		skill: "Vim",
		value: 20,
		color: "green",
		image: "/assets/Vim.png"
	},
	{
		skill: "React Router",
		value: 90,
		color: "blue",
		image: "/assets/ReactRouter.png"
	},
	{
		skill: "Netlify",
		value: 90,
		color: "teal",
		image: "/assets/Netlify.png"
	},
	{
		skill: "Firebase",
		value: 50,
		color: "yellow",
		image: "/assets/Firebase.png"
	},
	{
		skill: "MongoDB",
		value: 50,
		color: "green",
		image: "/assets/MongoDB.png"
	},
	{
		skill: "Stripe API",
		value: 30,
		color: "violet",
		image: "/assets/Stripe.jpg"
	},
	{
		skill: "LeafletJS",
		value: 40,
		color: "black",
		image: "/assets/Leaflet.png"
	}
];

export const softSkills = [
	{
		skill: "Communication",
		value: 100,
		color: "orange",
		image: "/assets/communication.png"
	},
	{
		skill: "Planning",
		value: 100,
		color: "yellow",
		image: "/assets/planning.png"
	},
	{
		skill: "Sales",
		value: 85,
		color: "blue",
		image: "/assets/sales.jpg"
	},
	{
		skill: "Management",
		value: 100,
		color: "red",
		image: "/assets/management.png"
	},
	{
		skill: "Teamwork",
		value: 100,
		color: "green",
		image: "/assets/Teamwork.png"
	},
	{
		skill: "Time Management",
		value: 100,
		color: "blue",
		image: "/assets/TimeManagement.png"
	},
	{
		skill: "Work Ethic",
		value: 100,
		color: "teal",
		image: "/assets/WorkEthic.png"
	},
	{
		skill: "Problem Solving",
		value: 100,
		color: "pink",
		image: "/assets/ProblemSolving.png"
	},
	{
		skill: "Interpersonal Skills",
		value: 100,
		color: "blue",
		image: "/assets/InterpersonalSkills.jpg"
	},
	{
		skill: "Adaptability",
		value: 100,
		color: "red",
		image: "/assets/Adaptability.png"
	},
	{
		skill: "Creativity",
		value: 100,
		color: "blue",
		image: "/assets/Creativity.png"
	},
	{
		skill: "Professionalism",
		value: 100,
		color: "pink",
		image: "/assets/Professionalism.png"
	},
	{
		skill: "Friendliness",
		value: 100,
		color: "yellow",
		image: "/assets/Friendliness.png"
	},

	{
		skill: "Respect",
		value: 100,
		color: "green",
		image: "/assets/Respect.png"
	},
	{
		skill: "Confidence",
		value: 100,
		color: "orange",
		image: "/assets/Confidence.png"
	},
	{
		skill: "Empathy",
		value: 100,
		color: "yellow",
		image: "/assets/Empathy.jpeg"
	},
	{
		skill: "Mediation",
		value: 100,
		color: "black",
		image: "/assets/Mediation.png"
	},
	{
		skill: "Negotiating",
		value: 100,
		color: "red",
		image: "/assets/Negotiating.png"
	},
	{
		skill: "Curiosity",
		value: 100,
		color: "blue",
		image: "/assets/Curiosity.png"
	},
	{
		skill: "Analysis",
		value: 100,
		color: "pink",
		image: "/assets/Analysis.png"
	}
];
